import { Page } from '../../../../types';

import '../../privacy/Privacy.css';

const CatMinerPrivacy: React.FC = () => {
  return (
    <div className="privacy">
      <h1>BIIIRD GAMES</h1>
      <h1>PRIVACY POLICY</h1>

      <p>for Cat Miner. Last Modified on 12/16/2024</p>
      <h2>What’s in this Privacy Policy?</h2>
      <p>This Privacy Policy explains:</p>
      <p>
        <ul>
          <li>What information we collect about you</li>
          <li>How we use that information</li>
          <li>What information we share with others</li>
          <li>Your rights and choices about your information</li>
        </ul>
      </p>
      <h2>What does this Privacy Policy cover?</h2>
      <p>
        We are biiird games LLC ("biiird games", "we", or "us"). This Privacy
        Policy applies to "Cat Miner" video game software and associated
        websites and software applications (we’ll refer to this as the
        "Service").
      </p>
      <p>
        By using the Service, you agree to the terms of this Privacy Policy.
        Please read our End User License Agreement as well, for general guidance
        about your use of the Service. Except as otherwise expressly agreed,
        this Privacy Policy and our End User License Agreement are the complete
        agreement between you and biiird games.
      </p>
      <h2>What Information Do We Collect?</h2>
      <p>
        We collect and process different types of personal data depending on how
        you interact with our Service. Here’s an overview of the information we
        collect:
      </p>
      <h3>Contact Information</h3>
      <p>
        When you interact with us (such as when you provide feedback and you
        request customer support), we collect certain contact information such
        as your email address and name.
      </p>
      <h3>Service Usage Information</h3>
      <p>
        As you use our Service, we may automatically collect usage information
        about your interactions, including your actions taken within the Service
        and service settings.
      </p>
      <p>
        We use this information to improve user experience and service
        performance, provide core service functionality, and save and sync your
        game progress across devices.
      </p>
      <h3>User Communication and Content</h3>
      <p>
        If you choose to use communication or content sharing features on the
        Service (including third-party community platforms, like Discord, that
        we may offer from time to time), we may collect any chat messages,
        comments, community contributions, feedback submissions, and forum posts
        that you transmit to us or other users through the Service.
      </p>
      <p>
        We use this information to enable social features, improve community
        features, maintain community standards, and provide customer support.
      </p>
      <p>
        Use of third party platforms is subject to those platforms’ terms of use
        and privacy policies.
      </p>
      <h2>How Do We Share Your Information?</h2>
      <p>
        <ul>
          <li>
            <strong>Technical Service Providers:</strong> We may share certain
            personal data with trusted service providers who help us operate and
            improve our Service, to deliver content efficiently, host our
            services and store your data securely, and track bugs and technical
            issues.
          </li>
          <li>
            <strong>Platform Partners:</strong> We share data with third-party
            platform partners to deliver game updates, enable platform-specific
            features, and sync game progress and saves.
          </li>
          <li>
            <strong>Social Platforms:</strong> When you utilize social
            functionality of the Service, we share data with third parties to
            provide community features.
          </li>
          <li>
            <strong>Analytics Providers:</strong> In order to analyze service
            usage and improve user experience, we may share data with
            third-party analytics service providers.
          </li>
        </ul>
      </p>
      <h2>How long do we keep your data?</h2>
      <p>
        We only keep your personal data as long as it’s required to provide you
        with the Service. Sometimes a longer period might be required by law.
      </p>
      <p>
        After that, we will delete your personal data within a reasonable time.
      </p>
      <p>Please note that we may retain some data, if necessary to:</p>
      <p>
        <ul>
          <li>resolve disputes,</li>
          <li>enforce our user agreements,</li>
          <li>
            follow any technical and legal requirements related to the Service.
          </li>
        </ul>
      </p>
      <h2>Children’s privacy rights</h2>
      <p>
        We don’t knowingly collect any personal data from children under the age
        of 13. We also don’t knowingly allow them to create accounts, sign up
        for newsletters, make purchases, or use the Service.
      </p>
      <p>
        We may also limit our personal data processing for EU users between 13
        and 16.
      </p>
      <p>
        We take children’s privacy seriously and encourage parents to play an
        active role in their children’s online experience. If you have any
        concerns about your child’s personal data, please contact us at{' '}
        <a href="mailto:support@biiirdgames.com">support@biiirdgames.com</a>.
      </p>
      <h2>Your Rights and Choices</h2>
      <p>
        We believe in giving users control over their personal data. This
        section outlines your rights (some of which may be based on where you
        reside) and how to exercise them.
      </p>
      <h3>All Users:</h3>
      <p>Regardless of your location, you have the right to:</p>
      <p>
        <ul>
          <li>Request deletion of your personal data</li>
          <li>Opt out of marketing communications</li>
          <li>Access and update your account information</li>
          <li>Control cookie settings through your browser</li>
          <li>Manage notification preferences</li>
        </ul>
      </p>
      <p>
        If you would like to exercise any of those rights, please email us at{' '}
        <a href="mailto:support@biiirdgames.com">support@biiirdgames.com</a>. We
        may ask for additional info to verify that you’re the owner of that
        data.
      </p>
      <h3>EU and UK Residents:</h3>
      <p>
        We are regulated under the General Data Protection Regulation (GDPR),
        which applies across the European Union. We are responsible as a
        controller of personal data for GDPR purposes.
      </p>
      <p>
        Additionally, UK residents have similar rights to the above under the UK
        General Data Protection Regulation (UK GDPR) and the Data Protection Act
        2018. For more information on your rights under the UK GDPR, you can
        visit the Information Commissioner's Office (ICO) website at{' '}
        <a href="http://www.ico.org.uk" target="_blank" rel="noreferrer">
          www.ico.org.uk
        </a>
        .
      </p>
      <h4>Legal Basis for processing your personal data:</h4>
      <p>
        In accordance with the General Data Protection Regulation (GDPR) and UK
        data protection law, we process your personal data based on the
        following legal grounds:
      </p>
      <p>
        <ul>
          <li>
            <strong>Consent.</strong> For personal data collected when you
            provide it to us directly, we may rely on your explicit consent. In
            these situations, you have the right to withdraw your consent at any
            time (see "How to Contact Us" below).
          </li>
          <li>
            <strong>Contractual Obligations.</strong> We process specific sets
            of your data to fulfill our contractual obligations to you. This
            encompasses actions like providing Service communications
            functionality, and general Service operations and delivery.
          </li>
          <li>
            <strong>Legitimate Interests.</strong> For certain data processing
            activities, we rely on our legitimate business interests. This
            includes activities like Service error correction, updates, and
            improvements, and ensuring a safe user environment.
          </li>
          <li>
            <strong>Legal Compliance.</strong> There are instances where we’re
            legally mandated to process your data. This could be due to
            regulatory requirements, legal requests, or for the prevention of
            fraud and illegal activities.
          </li>
        </ul>
      </p>
      <h4>Your rights under GDPR and UK GDPR:</h4>
      <p>Under the GDPR, EU and UK residents have several important rights:</p>
      <p>
        <ul>
          <li>You can request a copy of your personal data</li>
          <li>
            You can ask us to correct that personal data, delete it, or request
            that we use it only for certain purposes.
          </li>
          <li>
            If you’ve consented to our processing, you can change your mind and
            ask us to stop using your personal data. For example, you can
            unsubscribe from our mailing list at any time – just click the link
            in each marketing email.
          </li>
          <li>
            In some circumstances, you can ask us not to use automated
            processing or profiling about you.
          </li>
        </ul>
      </p>
      <p>
        If you would like to exercise any of those rights, please email us at{' '}
        <a href="mailto:support@biiirdgames.com">support@biiirdgames.com</a>. We
        may ask for additional info to verify that you’re the owner of that
        data.
      </p>
      <p>
        Also, in some cases where the law requires it, we may not be able to
        help with the above requests.
      </p>
      <h3>US Residents - State-Specific Privacy Rights:</h3>
      <p>
        For residents of states with comprehensive privacy laws (including
        California, Virginia, Colorado, Connecticut, Utah, Texas, and Oregon),
        you may have additional rights, depending on your state’s law.
      </p>
      <p>These include:</p>
      <h4>Access and Control Rights</h4>
      <p>
        <ul>
          <li>Request a copy of your personal data</li>
          <li>Correct inaccurate personal information</li>
          <li>Request deletion of your personal data</li>
          <li>Receive your data in a portable format</li>
        </ul>
      </p>
      <h4>Right to Opt Out of:</h4>
      <p>
        <ul>
          <li>Targeted advertising</li>
          <li>Sale of personal data</li>
          <li>Profiling and automated decision-making</li>
        </ul>
      </p>
      <h4>Important Notes</h4>
      <p>
        In addition to the above rights, we also agree to the following with
        respect to US users’ personal data:
      </p>
      <p>
        <ul>
          <li>
            We will not discriminate against you for exercising your rights
          </li>
          <li>We do not sell personal data as defined by state privacy laws</li>
          <li>
            We do not engage in automated decision-making that produces legal
            effects
          </li>
          <li>We protect sensitive personal data with additional safeguards</li>
        </ul>
      </p>
      <h4>California Resident Rights</h4>
      <p>
        In addition to the above rights, for California residents under the
        California Consumer Privacy Act (CCPA), you have the right to designate
        an authorized agent to make requests on your behalf.
      </p>
      <p>
        If you would like to exercise any of those rights, please email us at{' '}
        <a href="mailto:support@biiirdgames.com">support@biiirdgames.com</a>. We
        may ask for additional info to verify that you’re the owner of that
        data.
      </p>
      <h3>Canadian Residents:</h3>
      <p>
        For Canadian residents, we are committed to protecting your personal
        information in accordance with the Personal Information Protection and
        Electronic Documents Act (PIPEDA). PIPEDA’s ten fair information
        principles include accountability, identifying purposes, consent,
        limiting collection, limiting use, disclosure and retention, accuracy,
        safeguards, openness, individual access, and challenging compliance.
      </p>
      <p>
        Under PIPEDA, you have certain rights regarding your personal
        information. These rights include:
      </p>
      <p>
        <ul>
          <li>
            <strong>Right to Access:</strong> You have the right to access the
            personal information we hold about you and request a copy of that
            information.
          </li>
          <li>
            <strong>Right to Rectification:</strong> If you believe that any of
            the personal information we hold about you is inaccurate or
            incomplete, you have the right to request that we correct or update
            it.
          </li>
          <li>
            <strong>Right to Withdraw Consent:</strong> If you have previously
            provided your consent for the collection, use, or disclosure of your
            personal information, you have the right to withdraw that consent at
            any time. Please note that withdrawing your consent may affect our
            ability to provide certain services to you.
          </li>
          <li>
            <strong>Right to Object:</strong> You have the right to object to
            the collection, use, or disclosure of your personal information for
            certain purposes, such as direct marketing.
          </li>
          <li>
            <strong>Right to Erasure:</strong> In certain circumstances, you
            have the right to request the deletion or removal of your personal
            information from our records.
          </li>
          <li>
            <strong>Right to Data Portability:</strong> You have the right to
            request a copy of your personal information in a structured,
            commonly used, and machine-readable format, and to transmit that
            information to another organization.
          </li>
        </ul>
      </p>
      <p>
        If you would like to exercise any of those rights, please email us at{' '}
        <a href="mailto:support@biiirdgames.com">support@biiirdgames.com</a>. We
        will respond to your request or inquiry within a reasonable timeframe
        and in accordance with applicable laws. We may ask for additional info
        to verify that you’re the owner of that data.
      </p>
      <p>
        Please note that there may be limitations on these rights as set out in
        PIPEDA or other applicable laws.
      </p>
      <h2>Data Security</h2>
      <p>
        We have taken steps and put security measures in place to prevent the
        accidental loss or misuse of personal data.
      </p>
      <p>
        For example, we limit access to those who have a genuine business need.
        Those processing your information will do so only in an authorized
        manner.
      </p>
      <p>
        We also have procedures in place to deal with any suspected data
        security breach. We’ll notify you and any applicable regulator of a
        suspected data security breach when legally required.
      </p>
      <h2>International Data Transfers</h2>
      <p>Our headquarters is in the United States.</p>
      <p>
        No matter where you live, by using the Service you consent to the
        processing and transfer of your personal data in and to the United
        States. This processing will be under the privacy policies of third
        parties that we share personal data with.
      </p>
      <p>
        If you would like more information, please contact us (see "How to
        contact us" below).
      </p>
      <h2>Resolving Disputes</h2>
      <p>
        We hope that we can resolve any questions or concerns you raise about
        our use of your personal data.
      </p>
      <p>
        Please contact us at{' '}
        <a href="mailto:support@biiirdgames.com">support@biiirdgames.com</a> to
        let us know if you have questions or concerns. We will do our best to
        resolve the issue.
      </p>
      <p>
        For EU residents, the GDPR also gives you right to lodge a complaint
        with a supervisory authority. You may do this in the EEA state where you
        live, work, or where any alleged infringement occurred.
      </p>
      <h2>Changes to This Privacy Policy</h2>
      <p>We last updated this Privacy Policy on 12/16/2024.</p>
      <p>
        We may make further updates from time to time, which will be reflected
        in the latest version posted on the Service. For major changes, if we
        have your email address on file, we will inform you via email.
        Otherwise, we will post a message on the Service about the change.
      </p>
      <h2>How to Contact Us</h2>
      <p>
        Please contact us if you have any questions about this Privacy Policy or
        your personal data. You can do so by sending us an email at{' '}
        <a href="mailto:support@biiirdgames.com">support@biiirdgames.com</a>.
      </p>
    </div>
  );
};

const CatMinerPrivacyPage: Page = {
  FC: CatMinerPrivacy,
  name: 'Cat Miner',
  url: 'cat-miner-privacy',
};

export default CatMinerPrivacyPage;
